export default "__VITE_ASSET__Biktoahn__"